// extracted by mini-css-extract-plugin
export default {"redEnvelope":"style_redEnvelope__4cFxf"};